import Choices from "choices.js";

$(document).ready(/\/curriculum-management\/examination-regulation\/\d+\/module\/(\d+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {
    var updateSortIndexFunction = function (container) {
        $(container).find("input[name*=sort]").each(function (key, el) {
            $(el).val(key);
        });
    };
    var counterUpdateFunction = function () {
        var sumCreditPoints = 0;
        var sumPercentage = 0;
        $(".element-row select[name*=course] option:selected").each(function (i, el) {
            var creditPoints = Number.parseFloat($(el).data("credit-points"));
            var percentage = Number.parseFloat($(el).data("percentage"));
            if (!isNaN(creditPoints)) {
                sumCreditPoints += creditPoints;
            }
            if (!isNaN(percentage)) {
                sumPercentage += percentage;
            }
        });
        $(".credit-point-count").text(new Intl.NumberFormat('de-DE', {minimumFractionDigits: 1})
            .format(sumCreditPoints));
        $(".percentage-count").text(new Intl.NumberFormat('de-DE').format(sumPercentage));
    }
    var removalFunction = function (e) {
        var container = $(this).closest(".element-row-container");
        $(this).closest(".element-row").remove();
        updateSortIndexFunction(container);
        counterUpdateFunction();
    };
    $(".btn-add-row").click(function (e) {
        var container = $(this).closest("div.card").find(".element-row-container");
        var currentCount = container.find(".element-row").length;
        var template = container.data('template');
        template = template.replace(/__index__/g, currentCount);
        container.append(template);
        container.find(".js-choice").each(function () {
            this.choices = new Choices(this, window.choicesConfig(this))
        });
        container.find(".btn-remove-row:last").click(removalFunction);
        container.find(".element-row:last input[name*=sort]").val(currentCount);
        container.find(".element-row:last select").change(counterUpdateFunction);
    });
    $(".element-row-container .btn-remove-row").click(removalFunction);
    $(".element-row-container select").change(counterUpdateFunction);
    new Sortable($(".element-row-container").get(0), {
        handle: ".draggable",
        onEnd: function (evt) {
            updateSortIndexFunction(evt.target);
        },
    });
    new Sortable($(".element-row-container").get(1), {
        handle: ".draggable",
        onEnd: function (evt) {
            updateSortIndexFunction(evt.target);
        },
    });
    counterUpdateFunction();
});